import { get } from 'lodash'

export function dataToArray(data) {
  return Object.entries(data||[]).map(([key, value]) => ({key, ...value}))
}

export function watchEvent(firebase, {type, path, storeAs, ...params}) {
  if (params.queryParams) params.isQuery = true
  return firebase.watchEvent(type, path, storeAs, params)
}

export function unWatchEvent(firebase, {type, path, queryId, ...params}) {
  return firebase.unWatchEvent(type, path, queryId, params)
}

export function evaluateRules(rules, context) {
  const ror = rules.split('||').map(r => r.trim());
  return ror.some(rr => {
    const rand = rr.split('&&').map(r => r.trim());
    return rand.every(rule => {
        const [path, requiredValue] = rule.split('=').map(p => p.trim());
        const cleanRequiredValue = requiredValue.replace(/"/g, ''); // remove quotes
        const actualValue = (''+get(context, path, '')).toLowerCase();
        return actualValue.match(cleanRequiredValue)
    });
  });
}